import _extends from "@babel/runtime/helpers/extends";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import { startColumnResizing, ToolTipContent } from '@atlaskit/editor-common/keymaps';
import { tableMessages as messages } from '@atlaskit/editor-common/messages';
import Tooltip from '@atlaskit/tooltip';
import { TableCssClassName } from '../../types';
export var ColumnResizeWidget = function ColumnResizeWidget(_ref) {
  var startIndex = _ref.startIndex,
    endIndex = _ref.endIndex,
    includeTooltip = _ref.includeTooltip;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  if (!includeTooltip) {
    return jsx("div", {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
      className: TableCssClassName.RESIZE_HANDLE_DECORATION,
      "data-start-index": startIndex,
      "data-end-index": endIndex
    });
  }
  return jsx(Tooltip, {
    content: jsx(ToolTipContent, {
      description: formatMessage(messages.adjustColumns),
      keymap: startColumnResizing
    }),
    hideTooltipOnClick: true,
    hideTooltipOnMouseDown: true,
    position: "mouse",
    mousePosition: "auto-start"
  }, function (tooltipProps) {
    return jsx("div", _extends({
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
      className: TableCssClassName.RESIZE_HANDLE_DECORATION,
      "data-start-index": startIndex,
      "data-end-index": endIndex
      // Ignored via go/ees005
      // eslint-disable-next-line react/jsx-props-no-spreading
    }, tooltipProps));
  });
};